import { ReportStatus, ReportStatuses } from '@navstation-portal/reporting/data-model/vessel-reports';

// The status lives in the plural library, because the list reads it too. This
// re-export keeps the imports of the report under edit as they were.
export { ReportStatuses } from '@navstation-portal/reporting/data-model/vessel-reports';
export type { ReportStatus } from '@navstation-portal/reporting/data-model/vessel-reports';

// A report is only editable while it is still being filled in; once submitted
// (or archived/removed server-side) it must not be saved over.
const READ_ONLY_STATUSES: readonly ReportStatus[] = [
  ReportStatuses.Completed,
  ReportStatuses.Historical,
  ReportStatuses.Deleted,
];

export const isReadOnlyReportStatus = (status: ReportStatus | null | undefined): boolean =>
  !!status && READ_ONLY_STATUSES.includes(status);
